import { RouteFactory } from "@app/routePaths";
import { AdvertisementTypeEnum } from "@app/types/enums";
import internationalGlobalLogo from "@assets/verticals/international-global-logo-blue.svg";
import SCLogo from "@assets/verticals/standard-chartered-logo.svg";
import Advertisement from "@components/Advertisement/Advertisement";
import PrestitialAdWrapper from "@components/Advertisement/PrestitialAdWrapper";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import useGlobalAdSetting from "@hooks/useGlobalAdSetting";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function GlobalEnterpriseBanner(): React.ReactElement {
  const { isPrestitialEnabled, topOverlayImpressions, topOverlayValidity } =
    useGlobalAdSetting({
      targeting: { key: "page", value: "listing" },
    });

  return (
    <>
      <SectionMasthead
        link={RouteFactory.globalEnterprise}
        masthead={{
          alt: "Global Enterprise logo",
          src: internationalGlobalLogo,
          width: 150,
          height: 50,
        }}
      />

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex flex-row items-center justify-center gap-x-4 lg:justify-end">
          <span className="font-poppins text-base font-light uppercase">
            BROUGHT TO YOU BY
          </span>
          <img
            src={SCLogo}
            alt="Standard Charted Logo"
            width="80"
            height="45"
          />
        </div>
      </Banner>

      <Advertisement
        rootClassName="pb-6"
        adUnitProps={{
          slot: GoogleAdsSlotFactory.lb1(RouteFactory.globalEnterprise),
          type: AdvertisementTypeEnum.LB1,
        }}
      />

      <PrestitialAdWrapper
        slot={GoogleAdsSlotFactory.prestitial(RouteFactory.globalEnterprise)}
        {...{
          isPrestitialEnabled,
          topOverlayImpressions,
          topOverlayValidity,
        }}
      />
    </>
  );
}
